module.exports = __webpack_public_path__ + "img/dodatoc1.ba87cf86.png";